import { SuggestionItem } from '../contracts';
import { encodeAndStringify } from '../utils';

export default function normalizeSuggestionSelection(
  suggestion: SuggestionItem
) {
  const searchHash =
    'filters' in suggestion
      ? encodeAndStringify({
          filters: suggestion.filters
        })
      : suggestion.searchHash;

  return {
    buildKey: 'buildKey' in suggestion ? suggestion.buildKey : null,
    highlightedText: suggestion.highlightedText,
    href:
      'href' in suggestion
        ? suggestion.href
        : `/cars/filters?cvnaid=${searchHash}`,
    searchHash,
    searchType: suggestion.searchType,
    text: suggestion.text
  };
}
